import React, { useState } from "react";
import { FiSend, FiSave, FiUsers, FiCheckCircle } from "react-icons/fi";
import SendTestModal from "./SendTestModal";

const GoLiveSection = ({
  openDropdown,
  toggleDropdown,
  handleSubmit,
  selectedUsersCount,
  contactsCount,

  // NEW
  selectedTemplateData,
  templateId,
  variableValues,
  buttonValues,
  mediaFile,
  isMediaTemplate,
  tenantEmail,
  workflowConfig,
  customReplyConfig,
  optOutConfig,
  productsConfig,
  listMessageConfig,
}) => {
  const totalRecipients = selectedUsersCount + contactsCount;
  const [showTestModal, setShowTestModal] = useState(false);

  return (
    <div className="card mb-4 border-0 shadow-sm">
      <div
        className="card-header bg-white d-flex justify-content-between align-items-center py-3"
        onClick={toggleDropdown}
        style={{ cursor: "pointer" }}
      >
        <div className="d-flex align-items-center">
          <div
            className="step-number bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3"
            style={{
              width: "32px",
              height: "32px",
              fontSize: "14px",
              fontWeight: "600",
            }}
          >
            5
          </div>
          <div>
            <h5 className="mb-0">Review & Launch</h5>
            <small className="text-muted">Complete your campaign setup</small>
          </div>
        </div>
        <span className="text-muted fs-5">{openDropdown ? "▲" : "▼"}</span>
      </div>

      {openDropdown && (
        <div className="card-body pt-3">
          <div className="row">
            <div className="col-lg-8">
              <h6 className="fw-semibold mb-4">Campaign Summary</h6>

              <div className="mb-4">
                <div className="card border-0 bg-light">
                  <div className="card-body text-center">
                    <div className="d-flex align-items-center justify-content-center mb-2">
                      <FiUsers className="me-2 text-primary fs-4" />
                      <h6 className="mb-0">Recipients</h6>
                    </div>
                    <div className="d-flex align-items-baseline justify-content-center">
                      <span className="h3 mb-0 me-2 text-primary">
                        {totalRecipients}
                      </span>
                      <small className="text-muted">people</small>
                    </div>
                    {selectedUsersCount > 0 && contactsCount > 0 && (
                      <small className="text-muted d-block mt-2">
                        {selectedUsersCount} users + {contactsCount} contacts
                      </small>
                    )}
                  </div>
                </div>
              </div>

              <div className="card border-0 bg-light p-4 mb-4">
                <h6 className="fw-semibold mb-3">Message Delivery</h6>
                <p className="text-muted small mb-0">
                  Your campaign messages will be delivered to all selected
                  recipients at the scheduled time. You can track delivery
                  status from the campaigns dashboard.
                </p>
              </div>

              <div className="d-flex gap-3 flex-wrap">
                <button
                  className="btn btn-primary px-4 py-2 d-flex align-items-center"
                  onClick={handleSubmit}
                  style={{ borderRadius: "8px", fontWeight: "600" }}
                >
                  <FiSend className="me-2" />
                  Launch Campaign
                </button>

                <button
                  className="btn btn-outline-secondary px-4 py-2 d-flex align-items-center"
                  style={{ borderRadius: "8px" }}
                >
                  <FiSave className="me-2" />
                  Save as Draft
                </button>

                <button
                  className="btn btn-outline-primary px-4 py-2 d-flex align-items-center"
                  style={{ borderRadius: "8px" }}
                  onClick={() => setShowTestModal(true)}
                >
                  <FiSend className="me-2" />
                  Send Test
                </button>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="card border-0 bg-light p-3">
                <h6 className="fw-semibold mb-3">Ready to Launch?</h6>
                <ul className="list-unstyled small text-muted mb-4">
                  <li className="mb-2 d-flex">
                    <FiCheckCircle className="me-2 text-success mt-1 flex-shrink-0" />
                    <span>Campaign name is set</span>
                  </li>
                  <li className="mb-2 d-flex">
                    <FiCheckCircle className="me-2 text-success mt-1 flex-shrink-0" />
                    <span>Message template is selected</span>
                  </li>
                  <li className="mb-2 d-flex">
                    <FiCheckCircle className="me-2 text-success mt-1 flex-shrink-0" />
                    <span>Recipients are configured</span>
                  </li>
                  <li className="mb-2 d-flex">
                    <FiCheckCircle className="me-2 text-success mt-1 flex-shrink-0" />
                    <span>Schedule is set</span>
                  </li>
                  <li className="d-flex">
                    <FiCheckCircle className="me-2 text-success mt-1 flex-shrink-0" />
                    <span>Response actions are configured</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <SendTestModal
            show={showTestModal}
            onClose={() => setShowTestModal(false)}
            templateId={templateId}
            selectedTemplateData={selectedTemplateData}
            variables={variableValues}
            buttons={buttonValues}
            mediaFile={mediaFile}
            isMediaTemplate={isMediaTemplate}
            tenantEmail={tenantEmail}
            workflowConfig={workflowConfig}
            customReplyConfig={customReplyConfig}
            optOutConfig={optOutConfig}
            listMessageConfig={listMessageConfig}
            productsConfig={productsConfig}
          />
        </div>
      )}
    </div>
  );
};

export default GoLiveSection;